module.exports = __webpack_public_path__ + "img/login_bg.9488347.png";